import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';

export const useColorPaletteStatuses = defineStore('color-palette-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.colorPaletteStatus_GetList,
    dto: 'ColorPaletteStatusDto',
    create: api.colorPaletteStatus_Create,
    update: api.colorPaletteStatus_Update,
    delete: api.colorPaletteStatus_Delete,
    usage: api.colorPaletteStatus_GetUsage,
    signalR: 'ColorPaletteStatusUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.colorPaletteStatus_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  return {
    ...globalStoreBase,
    replace,
  };
});
